import React, { useState } from 'react';
import Input from '@app/react-common/components/input/Input';
import { SECTION_NAME_MAX_LENGTH } from './deliveryMethodDisplayOrder';

interface InlineSectionNameInputProps {
  initialName: string;
  onSubmitName: (name: string) => void;
  onCancel: () => void;
}

export const InlineSectionNameInput = ({ initialName, onSubmitName, onCancel }: InlineSectionNameInputProps) => {
  const [sectionName, setSectionName] = useState(initialName);

  const submitOrCancel = () => {
    const trimmedSectionName = sectionName.trim();
    if (trimmedSectionName) {
      onSubmitName(trimmedSectionName);
    } else {
      onCancel();
    }
  };

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      submitOrCancel();
    }
    if (event.key === 'Escape') {
      event.preventDefault();
      onCancel();
    }
  };

  return (
    <div className="delivery-method-sections__name-input">
      <Input
        type="text"
        autoFocus
        ariaLabel="Section name"
        wrapperDivClassName="delivery-method-sections__name-input__field"
        placeholder="Section name"
        maxLength={SECTION_NAME_MAX_LENGTH}
        value={sectionName}
        onChange={(event) => setSectionName(event.target.value)}
        onKeyDown={handleKeyDown}
        onBlur={submitOrCancel}
      />
      <span className="delivery-method-sections__name-input__hint">Press Enter to save · Esc to cancel</span>
    </div>
  );
};
